import { useEffect, useRef } from "react";

// Read-only push channel from our backend for a contest page. The server sends
// {type: "scores_updated" | "status_changed" | "members_changed"}; we call
// onEvent so the page re-fetches REST state. Reconnects with backoff.
export default function useContestSocket(code, onEvent) {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    if (!code) return undefined;
    const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");
    let ws;
    let closed = false;
    let retry = 1000;
    let timer;

    const connect = () => {
      ws = new WebSocket(`${base}/api/ws-contest/${code}`);
      ws.onopen = () => {
        retry = 1000;
      };
      ws.onmessage = (e) => {
        try {
          const msg = JSON.parse(e.data);
          if (msg.type && msg.type !== "hello") cbRef.current?.(msg);
        } catch {
          /* ignore */
        }
      };
      ws.onclose = () => {
        if (closed) return;
        timer = setTimeout(connect, retry);
        retry = Math.min(retry * 2, 30000);
      };
      ws.onerror = () => ws.close();
    };
    connect();
    const ping = setInterval(() => {
      if (ws?.readyState === 1) ws.send("ping");
    }, 25000);
    return () => {
      closed = true;
      clearInterval(ping);
      clearTimeout(timer);
      ws?.close();
    };
  }, [code]);
}
